module.exports = __webpack_public_path__ + "static/media/star-icon.907e24e8.svg";